(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
let mobileMenuContainer = document.getElementById('tbc-mobile-menu-container')
  
let mobileMenuTrigger = document.getElementById('tbc-mobile-menu-trigger')
mobileMenuTrigger.addEventListener('click', () => {
  mobileMenuContainer.style.display = "flex"
  setTimeout(() => {
    mobileMenuContainer.style.opacity = 1
  }, 250)
})

let mobileMenuClose = document.getElementById('tbc-mobile-menu-close')
mobileMenuClose.addEventListener('click', () => {
  mobileMenuContainer.style.opacity = 0
  setTimeout(() => {
    mobileMenuContainer.style.display = "none"
  }, 250)
})

  } catch(e) { console.error(e); }
})();
})();
